export const config = {
    authentication: {
        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        auth0domain: process.env.REACT_APP_AUTH_AUTH0_AUTHORITY,
        auth0ClientId: process.env.REACT_APP_AUTH_AUTH0_CLIENT_ID,
        msalClientId: process.env.REACT_APP_AUTH_MSAL_CLIENT_ID,
        msalAuthScope: process.env.REACT_APP_MSAL_AUTH_SCOPE,
        msalAuthority: process.env.REACT_APP_AUTH_MSAL_AUTHORITY,
        redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URI,
    }
}
